import {paginateDispatchInvoice} from './paginateDispatchInvoice';
const money=value=>Number(value).toFixed(2);
const escape=value=>String(value??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
export function estimateText({customer,destination,rows,total,date}){
  return ['ManaKirana — Customer estimate',`Date: ${date}`,customer?`Customer: ${customer}`:'',`Pricing: ${destination}`,...rows.map((r,i)=>`${i+1}. ${r.name} ${r.size} × ${r.qty} @ ₹${money(r.selling)} = ₹${money(r.total)}`),`Grand total: ₹${money(total)}`,'Estimate only. Availability and prices are subject to confirmation.'].filter(Boolean).join('\n');
}
export function estimateHtml(estimate){
  const {customer,destination,source,rows,total,date}=estimate;
  return `<!doctype html><html><head><title>ManaKirana Customer Estimate</title><style>@page {
              size:A5 portrait;
              margin: 8mm;
            }

            * {
              box-sizing: border-box;
            }

            body {
              font-family: Arial, sans-serif;
              margin: 0;
              padding: 0;
              width: 100%;
              max-width: 132mm;
              font-size: 8pt;
              color: #111827;
            }

            h2 {
              margin: 0 0 4px 0;
              font-size: 16pt;
            }

            .subtitle {
              margin-bottom: 10px;
              color: #475569;
              font-size: 12px;
            }

            .meta {
              display: grid;
              grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
              overflow-wrap: anywhere;
              gap: 5px 10px;
              margin-bottom: 10px;
              padding: 7px;
              border: 1px solid #d1d5db;
              border-radius: 8px;
              background: #f8fafc;
            }

            table {
              width: 100%;
              table-layout: fixed;
              border-collapse: collapse;
              margin-top: 12px;
              font-size: 8pt;
              line-height: 1.3;
            }

            th,
            td {
              border: 1px solid #333;
              padding: 4px 2px;
              overflow-wrap: anywhere;
              text-align: left;
              vertical-align: top;
            }

            th {
              background: #f1f5f9;
              font-weight: bold;
            }

            .text-center {
              text-align: center;
            }

            .text-right {
              text-align: right;
            }

            .footer {
              margin-top: 28px;
              display: grid;
              grid-template-columns: repeat(3, minmax(0, 1fr));
              gap: 12px;
              font-size: 8pt;
              font-weight: bold;
              break-inside: avoid;
            }

            .signature-line {
              display: block;
              border-bottom: 1px solid #333;
              height: 24px;
            }

            thead {
              display: table-header-group;
            }
            .dispatch-print-page { display: flow-root; break-after: page; page-break-after: always; }
            .dispatch-print-page:last-of-type { break-after: auto; page-break-after: auto; }
            .invoice-grand-total { margin-top: 10px; text-align: right; font-weight: bold; border-top: 2px solid #333; padding-top: 6px; }
            [data-dispatch-ending] { break-inside: avoid; }
            .page-number { text-align: right; margin-top: 8px; font-size: 7pt; }

            tr, .meta {
              break-inside: avoid;
            }

            @media screen {
              body {
                margin: 20px auto;
              }
            }

            @media print {
              body {
                width: 100%;
              }

              button {
                display: none;
              }
            }.text-right{font-size:7pt;white-space:nowrap} th{font-size:7pt} </style></head><body>
  <div data-dispatch-header><h2>ManaKirana</h2><div class="subtitle">Customer Estimate</div>
  <div class="meta"><div><b>Customer:</b> ${escape(customer||'-')}</div><div><b>Status:</b> ESTIMATE</div><div><b>Source:</b> ${escape(source||'-')}</div><div><b>Destination:</b> ${escape(destination)}</div><div><b>Date:</b> ${escape(date)}</div></div></div>
  <table data-dispatch-table><colgroup>${[5,25,12,6,9,11,10,11,11].map(width=>'<col style="width:'+width+'%"/>').join('')}</colgroup><thead><tr><th class="text-center">S.No</th><th>Product</th><th>Brand</th><th class="text-center">Qty</th><th class="text-center">Unit</th><th class="text-right">MRP</th><th class="text-right">Discount<br/>%</th><th class="text-right">D.Price</th><th class="text-right">Total Price</th></tr></thead><tbody>
  ${rows.map((r,i)=>`<tr data-line-total="${Number(r.total)}"><td class="text-center">${i+1}</td><td>${escape(r.name)}</td><td>${escape(r.brand||'-')}</td><td class="text-center">${escape(r.qty)}</td><td class="text-center">${escape(r.size)}</td><td class="text-right">${money(r.mrp)}</td><td class="text-right">${money(Number(r.mrp)>0?Math.max(0,(Number(r.mrp)-Number(r.selling))/Number(r.mrp)*100):0)}%</td><td class="text-right">${money(r.selling)}</td><td class="text-right">${money(r.total)}</td></tr>`).join('')}
  </tbody></table><div data-dispatch-ending><div class="invoice-grand-total">Grand total: ${money(total)}</div><p>Estimate only. Availability and prices are subject to confirmation.</p><div class="footer"><div>Prepared By:<span class="signature-line"></span></div><div>Checked By:<span class="signature-line"></span></div><div>Customer:<span class="signature-line"></span></div></div></div>
  <script>window.addEventListener('load',function(){(${paginateDispatchInvoice.toString()})(document);});</script></body></html>`;
}
